import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from "public/environments/environment";
import { BehaviorSubject } from 'rxjs';
import { ReportStatus } from 'projects/admin/src/app/features/complaints-settings/models/ComplaintsForms';

@Injectable({ providedIn: 'root' })

export class LookupsService {
  refreshList = new BehaviorSubject<boolean>(false);
  constructor(private http: HttpClient) {
  }

  GetMenu() {
    return this.http.get(`${environment.apiUrl}/Menu/GetMenuBasedOnPermissions`);
  }

  getReportTemplateLookup(PurposeType: ReportStatus) {
    return this.http.get(`${environment.apiUrl}/ReportTemplate/GetTemplateLkp?PurposeType=${PurposeType}`);
  }

  getSupportingDocumentTypes() {
    return this.http.get(`${environment.apiUrl}/Lookup/GetSupportingDocumentTypes`);
  }

  getLawLegislationRegulationTypes() {
    return this.http.get(`${environment.apiUrl}/Lookup/GetLawLegislationRegulationTypes`);
  }

  getInstitution() {
    return this.http.get(`${environment.apiUrl}/Lookup/GetInstitutionLookup`);
  }
  getLanguages() {
    return this.http.get(`${environment.apiUrl}/Lookup/GetLanguages`);
  }
  getCategoryTypes() {
    return this.http.get(`${environment.apiUrl}/Lookup/GetCategoryTypes`);
  }
  getLawLegislationRegulations() {
    return this.http.get(`${environment.apiUrl}/Lookup/GetLawLegislationRegulations`);
  }

  getCities() {
    return this.http.get(`${environment.apiUrl}/Lookup/GetCities`);
  }
}
